<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Services
	import { postReq } from '../../../services/http';
	//Configs
	import { devices_config } from '@devices/index';
	//Design system components
	import { Button, Checkbox, Select, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';

	export let device: Device;

	const id = device.id,
		save = async () => {
			waitForResponse = true;
			device.is_master = isMaster;
			device.master_device = selectedMaster === masterDevicesList[0] ? null : selectedMaster;
			const res = await postReq(`/interface/device/save`, {
				id,
				data: JSON.stringify(device),
			});
			let toastTexts = {};
			if (res?.isok) {
				if (intiIsMaster != isMaster) {
					toastTexts = {
						success: isMaster
							? $format('device_is_master_scc_toast', {
									default: 'Device set as Master.',
								})
							: $format('device_is_master_scc_toast', {
									default: 'Device is no longer a Master.',
								}),
					};
					intiIsMaster = isMaster;
					device.is_master = isMaster;
				}

				if (initSelectedMaster !== selectedMaster) {
					toastTexts = {
						success:
							selectedMaster !== masterDevicesList[0]
								? $format('device_is_master_scc_toast', {
										default: `Selected ${$devices[selectedMaster].name} as Master.`,
									})
								: $format('device_is_master_scc_toast', {
										default: 'Removed Master device',
									}),
					};
					initSelectedMaster = selectedMaster;
					device.master_device = selectedMaster;
				}

				devices.update(device);
			}
			onSettingsResponse(res, device, toastTexts);
			waitForResponse = false;
		};

	let no_room_cons = $devices[id].no_room_cons || false,
		no_account_cons = $devices[id].no_account_cons || false,
		waitForResponse = false;

	let isMaster = $devices[id].is_master || false,
		intiIsMaster = isMaster,
		selectedMaster = $devices[id].master_device || null,
		initSelectedMaster = selectedMaster;

	const devicesFilter = (devicesList) => {
		return [
			'none',
			...Object.keys(devicesList).filter((dId) => {
				// if (dId.indexOf('_') === -1) {
				// if (dId === '84cca87f1974') {
				// 	console.log('$devices[dId]', $devices[dId]);
				// }
				if (devices_config[$devices[dId].type]?.isPM && $devices[dId].is_master) {
					return dId;
				}
				// }
			}),
		];
	};

	$: masterDevicesList = devicesFilter($devices);

	const masterDevice = [
		// devices,
		// {
		// 	title: 'Online',
		// 	value: 'online'
		// },
		// {
		// 	title: 'Offline',
		// 	value: 'offline'
		// }
	];
</script>

<!-- <Checkbox size="m" bind:checked={no_room_cons} id="checkbox-tuvypa8">{$format('exclude_from_total_room_energy') ||
		'Exclude from total room energy.'}</Checkbox
>

<Checkbox size="m" bind:checked={no_account_cons} class="mb-s" id="checkbox-x2pvuua">{$format('exclude_from_total_total_energy') ||
		'Exclude from total account energy.'}</Checkbox
> -->

<Checkbox size="m" bind:checked={isMaster} class="mb-s" id="checkbox-gw4mrw5"
	>{$format('is_master_label', { default: 'Is a "Master" device' })}</Checkbox
>

{#if !intiIsMaster}
	<Text class="mb-m" element="h2">
		{$format('label_select_master_device', {
			default: 'Select "Master" device',
		})}
	</Text>

	<Select
		class="width-full mb-m "
		bind:value={selectedMaster}
		options={masterDevicesList}
		icon="fas fa-crown"
		label={masterDevicesList.length === 0
			? $format('label_no_master_devices', {
					default: 'No Master devices',
				})
			: $format('label_select_master', {
					default: 'Select Master',
				})}
		disabled={masterDevicesList.length === 0}
		id="select-rajmoef"
		aria-labelledby="select-rajmoef"
	/>
{/if}

<Button
	size="m"
	width="full"
	class="text-uppercase"
	disabled={isMaster == intiIsMaster && initSelectedMaster == selectedMaster}
	on:click={save}
	loading={waitForResponse}
	>{$format('button_apply', { default: 'apply' })}
</Button>
